// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getTiposNoticia as listTiposAPI,
    getTipoNoticia as getTipoAPI,
    addTipoNoticia as addTipoAPI,
    updateTipoNoticia as updateTipoAPI,
    deleteTipoNoticia as deleteTipoAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { tiposNoticiaApiResponseError, tiposNoticiaApiResponseSuccess } from './actions';
import { TiposActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getTipo({ payload: { id } }) {
    try {
        const response = yield call(getTipoAPI, id );
        const tipoItem = response.data.data;
        yield put(tiposNoticiaApiResponseSuccess(TiposActionTypes.GET_TIPO, tipoItem));
    } catch (error) {
        yield put(tiposNoticiaApiResponseError(TiposActionTypes.GET_TIPO, error));
    }
}

function* addTipo({payload:tipo}){
    try{
        const response = yield call(addTipoAPI,{...tipo})
        const tipoItem = response.data
        yield put(tiposNoticiaApiResponseSuccess(TiposActionTypes.ADD_TIPO,tipoItem))
    } catch(error){
        yield put(tiposNoticiaApiResponseError(TiposActionTypes.ADD_TIPO,error))
    }
}

function* updateTipo({payload:tipo}){
    try{
        const response = yield call(updateTipoAPI,{...tipo})
        const tipoItem = response.data.data
        yield put(tiposNoticiaApiResponseSuccess(TiposActionTypes.UPDATE_TIPO,tipoItem))
    }catch(error){
        yield put(tiposNoticiaApiResponseError(TiposActionTypes.UPDATE_TIPO,error))
    }
}
function* deleteTipo({payload:{id}}){
    try{
        const response = yield call(deleteTipoAPI,id)
        const tipoItem = response.data.id
        yield put(tiposNoticiaApiResponseSuccess(TiposActionTypes.DELETE_TIPO,tipoItem))
    }catch(error){
        yield put(tiposNoticiaApiResponseError(TiposActionTypes.DELETE_TIPO,error))
    }
}

/**
 * List contactos
 */
function* listTipos({payload:params}) {
    try {
        const response = yield call(listTiposAPI, { ...params });
        const listaTipos = response.data.data;
        yield put(tiposNoticiaApiResponseSuccess(TiposActionTypes.LIST_TIPOS, listaTipos));
    } catch (error) {
        yield put(tiposNoticiaApiResponseError(TiposActionTypes.LIST_TIPOS, error));
    }
}


export function* watchGetTipo(): any {
    yield takeEvery(TiposActionTypes.GET_TIPO, getTipo);
}

export function* watchListTipos(): any {
    yield takeEvery(TiposActionTypes.LIST_TIPOS, listTipos);
}

export function* watchAddTipo():any{
    yield takeEvery(TiposActionTypes.ADD_TIPO,addTipo)
}
export function* watchUpdateTipo():any{
    yield takeEvery(TiposActionTypes.UPDATE_TIPO,updateTipo)
}
export function* watchDeleteTipo():any{
    yield takeEvery(TiposActionTypes.DELETE_TIPO,deleteTipo)
}


function* tiposSaga(): any {
    yield all([
        fork(watchGetTipo),
        fork(watchListTipos),
        fork(watchAddTipo),
        fork(watchUpdateTipo),
        fork(watchDeleteTipo),
    ]);
}

export default tiposSaga;
